<template>
  <generic-modal :title="$t('product')" ref="generic_modal">
    <form>
      <!-- DPI del Cliente -->
      <div class="field">
        <label class="label">{{ $t("name") }}</label>
        <div class="control">
          <input
            class="input"
            type="text"
            v-model="meta.name"
            :placeholder="$t('name')"
            required
          />
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("currency") }}</label>
        <div class="select">
          <select v-model="meta.settings.currency">
            <option value="GTQ">{{ $t("guatemalan quetzal") }}</option>
            <option value="USD">{{ $t("us dollar") }}</option>
          </select>
        </div>
      </div>
      <!-- Documentacion solicitada -->
      <div class="field">
        <label class="label">{{ $t("documentation") }}</label>
        <div
          class="field has-addons"
          v-for="(doc, index) in meta.settings.documentation"
          :key="index"
        >
          <div class="control is-expanded">
            <input
              class="input"
              type="text"
              v-model="meta.settings.documentation[index]"
              :placeholder="$t('document name')"
              required
            />
          </div>
          <div class="control">
            <button
              type="button"
              class="button is-danger"
              @click="meta.settings.documentation.splice(index, 1)"
            >
              <span class="icon">
                <i class="fa fa-trash"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
      <button
        type="button"
        class="button is-link is-small"
        @click="meta.settings.documentation.push('')"
      >
        <span class="icon">
          <i class="fa fa-plus"></i>
        </span>
        <span>{{ $t("add document") }}</span>
      </button>
    </form>

    <!-- Mensajes de error -->
    <div class="notification is-danger mt-5" v-if="error" v-html="error"></div>

    <!-- PATRÓN CORRECTO: usar v-slot:footer -->
    <template v-slot:footer>
      <button
        class="button is-success"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button" @click="close_modal">
        <span class="icon">
          <i class="fa fa-times"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/generic_modal/Index.vue";
import {
  post,
  put,
  get,
  success_message,
  error_message,
  generate_error_message,
} from "@/utils";

export default {
  name: "ProductModal",
  components: { GenericModal },
  data() {
    return {
      meta: {
        name: "",
        settings: {
          documentation: [],
        },
      },
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      return !this.meta.name.trim();
    },
  },
  methods: {
    show_modal(uuid = null) {
      let v = this;
      v.meta.uuid = uuid;
      v.$refs.generic_modal.show_modal();
      if (uuid) {
        v.get_product(uuid);
      }
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    set_initial_state() {
      this.meta = {
        name: "",
        settings: {
          documentation: [],
        },
      };
      this.error = "";
    },
    get_product(uuid) {
      let v = this;
      get("/account-request/product", { uuid: uuid })
        .then((response) => {
          if (response.settings && !response.settings.documentation)
            response.settings.documentation = [];

          v.meta = response;
        })
        .catch((error) => {
          v.error = error_message(error);
        });
    },
    save() {
      let v = this;
      if (v.is_form_invalid) {
        v.error = "Por favor complete los campos requeridos";
        return;
      }

      v.error = "";
      let data = { ...v.meta };

      if (data.uuid) {
        post("/account-request/product", data)
          .then(() => {
            success_message(v.$t("product updated successfully"));
            v.close_modal();
            v.$emit("success");
          })
          .catch((error) => {
            v.error = generate_error_message(error);
          });
      } else {
        put("/account-request/product", data)
          .then(() => {
            success_message(v.$t("product created successfully"));
            v.close_modal();
            v.$emit("success");
          })
          .catch((error) => {
            v.error = error;
          });
      }
    },
  },
};
</script>

<style scoped>
.modal-card {
  width: 600px;
  max-width: 90vw;
}
</style>
